var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.505.625H1.255a.75.75 0 00-.75.75v17.25c0 .415.335.75.75.75h17.25a.75.75 0 00.75-.75V1.375a.75.75 0 00-.75-.75zM16.34 6.098h-1.498c-1.174 0-1.402.557-1.402 1.378v1.807h2.804l-.366 2.829H13.44v7.263h-2.922v-7.26H8.073V9.282h2.445V7.197c0-2.421 1.479-3.74 3.64-3.74 1.036 0 1.924.077 2.184.112v2.529h-.002z",
    fill: "#0E0E0E"
  })));
}
export default SvgFacebook;